<span [title]="title" class="icon" [ngClass]="iconClasses"><ng-content></ng-content></span>
